import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  client: {
    NEXT_PUBLIC_DATOCMS_API_TOKEN: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string().optional(),
    NEXT_PUBLIC_POSTHOG_ID: z.string().optional(),
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().min(1),
    NEXT_PUBLIC_VERCEL_URL: z
      .string()
      .min(1)
      .transform((url) => {
        if (process.env["NEXT_PUBLIC_VERCEL_ENV"] === "production") {
          return "www.triptojapan.com";
        }
        return url;
      }),
    NEXT_PUBLIC_MAPBOX_TOKEN: z.string(),
    NEXT_PUBLIC_LOCALHOST_EXTERNAL_HOST: z.string().optional(),
    NEXT_PUBLIC_GOOGLE_API_KEY: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_AUTH_CLIENT_ID: z.string(),
    NEXT_PUBLIC_WORKER_URL: z.string().min(1),
    NEXT_PUBLIC_ZERO_SYNC_URL: z.string().url(),
  },
  server: {
    BOKUN_ACCESS_TOKEN: z.string().min(1),
    BOKUN_API_KEY: z.string(),
    BOKUN_HOST: z.string(),
    BOKUN_SECRET_KEY: z.string(),
    LINKTIVITY_API_HOST: z.string(),
    LINKTIVITY_API_KEY_ID: z.string(),
    LINKTIVITY_API_KEY: z.string(),
    LINKTIVITY_GROUP_ID: z.string(),
    LINKTIVITY_OTA_ID: z.string(),
    DATABASE_URL: z.string().min(1),
    DKIM_DOMAIN: z.string().min(1),
    DKIM_PRIVATE_KEY: z.string().min(1),
    DKIM_SELECTOR: z.string().min(1),
    SECRET: z.string().min(1),
    STRIPE_ENDPOINT_SECRET: z.string().min(1),
    STRIPE_SECRET_KEY: z.string().min(1),
    VERCEL_ENV: z
      .enum(["production", "preview", "development"])
      .default("development"),
    VERCEL_URL: z
      .string()
      .min(1)
      .transform((url) => {
        if (process.env["NEXT_PUBLIC_VERCEL_ENV"] === "production") {
          return "www.triptojapan.com";
        }
        return url;
      }),
    SENTRY_DSN: z.string().url().optional(),
    SENTRY_AUTH_TOKEN: z.string().min(1).optional(),
    FACEBOOK_PIXEL_ACCESS_TOKEN: z.string().min(1),
    GOOGLE_AUTH_CLIENT_SECRET: z.string().min(1),
    POSTHOG_PERSONAL_API_KEY: z.string().min(1),
    DATOCMS_WEBHOOK_TOKEN: z.string().min(1),
    POSTMARK_SERVER_API_TOKEN: z.string().min(1),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_DATOCMS_API_TOKEN: process.env["NEXT_PUBLIC_DATOCMS_API_TOKEN"],
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID:
      process.env["NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID"],
    NEXT_PUBLIC_POSTHOG_ID: process.env["NEXT_PUBLIC_POSTHOG_ID"],
    NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY:
      process.env["NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY"],
    NEXT_PUBLIC_VERCEL_URL:
      process.env["NEXT_PUBLIC_VERCEL_ENV"] === "production"
        ? "www.triptojapan.com"
        : process.env["NEXT_PUBLIC_VERCEL_URL"],
    NEXT_PUBLIC_MAPBOX_TOKEN: process.env["NEXT_PUBLIC_MAPBOX_TOKEN"],
    NEXT_PUBLIC_GOOGLE_API_KEY: process.env["NEXT_PUBLIC_GOOGLE_API_KEY"],
    NEXT_PUBLIC_LOCALHOST_EXTERNAL_HOST:
      process.env["NEXT_PUBLIC_LOCALHOST_EXTERNAL_HOST"],
    NEXT_PUBLIC_GOOGLE_AUTH_CLIENT_ID:
      process.env["NEXT_PUBLIC_GOOGLE_AUTH_CLIENT_ID"],
    NEXT_PUBLIC_WORKER_URL: process.env["NEXT_PUBLIC_WORKER_URL"],
    NEXT_PUBLIC_ZERO_SYNC_URL: process.env["NEXT_PUBLIC_ZERO_SYNC_URL"],
  },
});
